import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "./ViewMessageDataForm";
import GraphQLErrors from "../../components/GraphQLErrors";
import {cancelViewEdiMessageData} from "../../actions/ShippingApiActions";
import Loading from "../../components/Loading";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";

class ViewEdiMessageDataFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleCancel() {
    this.props.cancelViewEdiMessageData();
  }

  handleDelete() {
    return this.props.deleteIncomingEdiMessage({id: this.props.id})
      .then((response) => {
        if (response.data.deleteIncomingEdiMessage.errors.length <= 0) {
          this.props.cancelViewEdiMessageData();
        } else {
          let errors = createValidationErrors(response.data.deleteIncomingEdiMessage.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      }); 
  }

  render() {
    let {data} = this.props;
    if (data.loading) return <Loading />
    if (data.error) return <GraphQLErrors error={data.error} />    
    return (
      <Form
        errors={this.state.errors}
        data={data.incomingEdiMessage.data}
        message={"Are you sure you want to remove this package?"}
        onCancel={this.handleCancel.bind(this)}
        onDelete={this.handleDelete.bind(this)}
        />
    )
  }
}

const EDI_MESSAGE = gql`
  query incomingEdiMessage($id:Int!) {
    incomingEdiMessage(id: $id) {
      id
      data
    }
  }
`;

const DELETE_MESSAGE = gql`
  mutation deleteIncomingEdiMessage($id:Int!) {
    deleteIncomingEdiMessage(id: $id) {
      errors { key message }
    }
  }
`;


const withQuery = compose(
  graphql(EDI_MESSAGE, {
    options: (props) => ({
      fetchPolicy: "network-only",
      variables: {
        id: props.id
      }
    })
  }),
  graphql(DELETE_MESSAGE, {
    props: ({mutate}) => ({
      deleteIncomingEdiMessage: (data) => mutate({
        variables: data
      })
    })
  })
);

export default connect(null, {cancelViewEdiMessageData})(withQuery(ViewEdiMessageDataFormContainer));